export var KeyboardControlKeys = {
    RETURN: 'RETURN',
    CAPSLOCK: 'CAPSLOCK',
    BACKSPACE: 'BACKSPACE',
    SPACE: 'SPACE',
    ENTER: 'ENTER',
};
export var handleKeyboardEvent = function (value, keyboardEvent) {
    var key = keyboardEvent.key;
    switch (key.toUpperCase()) {
        case KeyboardControlKeys.SPACE:
            return {
                value: value + ' ',
                control: '',
            };
        case KeyboardControlKeys.BACKSPACE:
            return {
                value: value.slice(0, -1),
                control: '',
            };
        case KeyboardControlKeys.RETURN:
            return {
                value: value,
                control: KeyboardControlKeys.RETURN,
            };
        case KeyboardControlKeys.ENTER:
            return {
                value: value + '\n',
                control: '',
            };
        default:
            return {
                value: value + key,
                control: '',
            };
    }
};
//# sourceMappingURL=keyboard.js.map